import { __read } from "tslib";
import { runBeforeLayout } from '@office-start/performance-utility';
import { IDLE_MEDIUM_PRIORITY, scheduleWork, } from '@office-start/scheduler-service';
import { useEffect, useRef, useState } from 'react';
export function useActivityRenderer() {
    var _a = __read(useState(false), 2), activityRenderingPhase = _a[0], setActivityRenderingPhase = _a[1];
    var workHandle = useRef(null);
    useEffect(function () {
        workHandle.current = scheduleWork(function () {
            return runBeforeLayout(function () {
                setActivityRenderingPhase(true);
            });
        }, IDLE_MEDIUM_PRIORITY);
        return function () {
            var _a;
            (_a = workHandle.current) === null || _a === void 0 ? void 0 : _a.cancel();
        };
    }, []);
    return activityRenderingPhase;
}
//# sourceMappingURL=useActivityRenderer.js.map